import React, { useState, useEffect } from "react"
import { BlobContainer } from "./styles"
import Blob from "../Blob"

const getBlobDimension = innerWidth => {
  if (innerWidth > 0) {
    if (innerWidth < 767) {
      return {
        size: {
          width: 1,
          height: 150,
        },
        padding: {
          x: 0,
          y: -75,
        },
      }
    } else if (innerWidth < 1024) {
      return {
        size: {
          width: 1,
          height: 150,
        },
        padding: {
          x: 0,
          y: -75,
        },
      }
    }
  }
  return {
    size: {
      width: 1,
      height: 200,
    },
    padding: {
      x: 0,
      y: 0,
    },
  }
}

const HeroBlob = ({ blobColors, innerWidth }) => {
  const [size, updateSize] = useState({ width: 1, height: 200 })
  const [padding, updatePadding] = useState({ x: 0, y: 0 })
  useEffect(
    () => {
      const { size: newSize, padding: newPadding } = getBlobDimension(
        innerWidth
      )
      updateSize(newSize)
      updatePadding(newPadding)
    },
    [innerWidth]
  )
  return (
    <Blob
      size={{
        ...size,
        fluid: true,
        fixedHeight: true,
        widthIncr: 1,
      }}
      padding={{ ...padding }}
      position={{ x: 0.5, y: 0 }}
      strength="50"
      gradient={{ c1: "#F49593", c2: "#F7BF28", rot: 0 }}
      points={{ num: 32 }}
      smoothRatioResize
      blobColors={blobColors.map(item => {
        if (
          item.text &&
          item.text !== "undefined" &&
          typeof item.text === "string"
        ) {
          return item.text
        }
        return "#fff"
      })}
    />
  )
}

const HeroBlobWithTitle = ({
  blobColors = [],
  headerHeight = 0,
  innerWidth = 0,
}) => (
  <BlobContainer headerHeight={headerHeight}>
    <HeroBlob blobColors={blobColors} innerWidth={innerWidth} />
  </BlobContainer>
)
export default HeroBlobWithTitle
